// @flow
import React from 'react';
import { LoadScript, GoogleMap, Marker } from '@react-google-maps/api';
import mapStyles from './mapStyles';

type Props = {
  center: Object,
  markerPosition: Object,
  zoom: Number
};

const Map = ({ center, zoom, markerPosition }: Props) => (
  <LoadScript
    googleMapsApiKey="AIzaSyCgGuxSwI5euVclysvDxrkBWx08at3gaVk"
    libraries={['geometry', 'drawing', 'places']}
    version="3.exp"
    loadingElement={<div style={{ height: `100%` }} />}
  >
    <GoogleMap
      center={center}
      zoom={zoom}
      mapContainerStyle={{ height: '100%' }}
      options={{
        styles: mapStyles,
        disableDefaultUI: true
      }}
    >
      <Marker
        position={markerPosition}
        options={{ icon: '/assets/img/map4.png' }}
      />
    </GoogleMap>
  </LoadScript>
);

export default Map;
